import { useState } from "react"
import { Navigate, useNavigate } from "react-router-dom"
import { computed } from "mobx"
import { observer } from "mobx-react"
import { choose } from "choose-matching"

import { DefaultPageLayout } from "@src/app/layouts/DefaultPageLayout"
import { paths } from "@src/app/paths"
import { GlobalOTP } from "@src/pages/otpConfirm/classes/GlobalOTP"
import { OTPSuccessScreen } from "@src/pages/otpConfirm/SuccessScreen"
import { FormOTP } from "@src/shared/componemts/FormOTP"

export const OtpConfirmPage = observer(() => {
  const [isVisible, setIsVisible] = useState(true)
  const globalOTP = GlobalOTP()
  const nav = useNavigate()

  const entity = computed(() => globalOTP.entity).get()

  if (!entity) {
    return <Navigate to={paths.default} />
  }

  return (
    <DefaultPageLayout
      backAction={() => nav(entity.backPath)}
      title={"2FA check"}
    >
      <>
        {choose(
          [
            isVisible,
            <FormOTP
              onSubmit={globalOTP.onSubmit}
              setVisible={setIsVisible}
            ></FormOTP>,
          ],
          [!isVisible, <OTPSuccessScreen entity={entity} />],
        )}
      </>
    </DefaultPageLayout>
  )
})
